<template>
  <w-modal
    v-model="isOpen"
    id="onboarding-modal"
    size="medium"
    class="onboarding-modal"
    :title="title"
    :close-on-click-outside="false"
    @close="onClose"
  >
    <template #body>
      <div class="modal-body">
        <slot name="body">
          <!-- 1. Imagem -->
          <div class="onboarding-image-container">
            <img src="https://cdn.feegow.com/noa/onboarding.png" alt="Logo" class="onboarding-image" />
          </div>

          <!-- 2. Texto de 2 linhas lado a lado -->
          <div class="onboarding-text-container px-4">
            <div class="onboarding-text-column">
              <w-text type="body"
              >Conheça o Noa Notes e deixe-o fazer anotações durante suas consultas e criar resumos estruturados para
                você.</w-text
              >
            </div>
          </div>
          <div class="onboarding-columns-container px-4">
            <div class="onboarding-column">
              <w-icon name="clock-filled" size="large" color="accent"></w-icon>

              <w-text type="body">Reduza o tempo gasto com anotações e dedique-o aos seus pacientes.</w-text>
            </div>
            <div class="onboarding-column-divider"></div>
            <div class="onboarding-column">
              <w-icon name="pen" size="large" color="accent"></w-icon>

              <w-text type="body">Mantenha o controle. Revise e edite o resumo a qualquer momento.</w-text>
            </div>
            <div class="onboarding-column-divider"></div>
            <div class="onboarding-column">
              <w-icon name="lock" size="large" color="accent"></w-icon>

              <w-text type="body">Seus dados estão protegidos com os mais altos padrões de criptografia.</w-text>
            </div>
          </div>

          <div class="onboarding-terms-container px-4">
            <w-text type="body" class="onboarding-terms-text">
              Ao iniciar a transcrição, você concorda com nossos
              <w-link target="_blank" :href="termsUrl">Termos e Condições</w-link>. Peça permissão ao seu paciente antes
              de começar a transcrever o áudio.
            </w-text>
          </div>
        </slot>
      </div>
      <div class="modal-footer">
        <slot name="footer">
          <w-button
            :label="secondaryButtonLabel"
            variant="secondary"
            @click="onSecondaryButtonClick"
            :loading="loading"
          />
          <w-button :label="primaryButtonLabel"
variant="primary" @click="onPrimaryButtonClick"
:loading="loading" />
        </slot>
      </div>
    </template>
  </w-modal>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

interface Props {
  isOpen: boolean;
  title?: string;
  primaryButtonLabel?: string;
  secondaryButtonLabel?: string;
  loading?: boolean;
  termsUrl?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Seleção Inicial",
  primaryButtonLabel: "Continuar",
  secondaryButtonLabel: "Continuar",
  loading: false,
  termsUrl: "https://feegow.com/termos-e-condicoes",
});

const emit = defineEmits(["close", "primary-button-click", "secondary-button-click"]);

const isOpen = ref(props.isOpen);

watch(
  () => props.isOpen,
  (newValue) => {
    isOpen.value = newValue;
  },
);

watch(isOpen, (newValue) => {
  if (!newValue) {
    emit("close");
  }
});

const onClose = () => {
  isOpen.value = false;
};

const onPrimaryButtonClick = () => {
  emit("primary-button-click");
  localStorage.setItem("aiAssistant.onboardingModalShown", "true");
};

const onSecondaryButtonClick = () => {
  emit("secondary-button-click");
  localStorage.setItem("aiAssistant.onboardingModalShownDate", new Date().toISOString());
};
</script>

<style>
#onboarding-modal .w-modal-body {
  padding: 0 !important;
}
#onboarding-modal .modal-body {
  gap: 0 !important;
  padding: 0 !important;
}
</style>

<style scoped lang="scss">
@import "style-variables.scss";

.modal-body {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  gap: var(--w-space-l);
}

.onboarding-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: var(--w-space-s);
}

.onboarding-image {
  width: 100%;
  height: auto;
}

.onboarding-text-container {
  display: flex;
  gap: var(--w-space-m);
  width: 100%;
}

.onboarding-text-column {
  flex: 1;
}

.onboarding-columns-container {
  display: flex;
  align-items: center;
  gap: var(--w-space-m);
  width: 100%;
  padding: var(--w-space-m) 0;
  justify-content: center;
}

.onboarding-column {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: var(--w-space-s);
  flex-direction: column;
}

.onboarding-columns-container :deep(.w-divider) {
  align-self: stretch;
  height: auto;
}

.onboarding-terms-container {
  margin-top: var(--w-space-s);
  text-align: center;
}

.onboarding-terms-text {
  color: var(--w-text-color-secondary);
  font-weight: 300;
  font-size: 0.875rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--w-space-s);
  padding: var(--w-space-m);
  padding-top: var(--w-space-l);
  margin-top: var(--w-space-m);
  border-top: 1px solid var(--w-border-color);
}
.onboarding-column-divider {
  background-color: #dbdbdb;
  height: 20px;
  width: 1px;
}
.px-4 {
  padding-left: var(--w-space-m);
  padding-right: var(--w-space-m);
  padding-top: 0;
  padding-bottom: 0;
}
.mb-4 {
  margin-bottom: -15px;
}
</style>

<style>
.onboarding-modal {
  z-index: 9999999999 !important;
}

.onboarding-modal .w-modal-backdrop {
  z-index: 9999999998 !important;
}
</style>

